import { render, staticRenderFns } from "./VCandidatesBrowse.vue?vue&type=template&id=5efd7edd&scoped=true&lang=pug"
import script from "./VCandidatesBrowse.vue?vue&type=script&lang=ts"
export * from "./VCandidatesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VCandidatesBrowse.vue?vue&type=style&index=0&id=5efd7edd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd7edd",
  null
  
)

/* custom blocks */
import block0 from "./EmployerCandidates.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FCandidates%2FBrowse%2FVCandidatesBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports